import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { DunaDashboardComponent } from '../duna-dashboard/duna-dashboard.component';

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

@Component({
  selector: 'app-duna-dashboard-public',
  standalone: true,
  imports: [MatCardModule, DunaDashboardComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="duna-dashboard-public">
      @if (linkErrorMessage) {
      <mat-card class="error-card">
        <mat-card-content>{{ linkErrorMessage }}</mat-card-content>
      </mat-card>
      } @else if (linkUuid) {
      <app-duna-dashboard
        [shareLinkGuid]="linkUuid"
        viewMode="publicShare"
      ></app-duna-dashboard>
      }
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        height: 100vh;
        min-height: 100vh;
      }
      .duna-dashboard-public {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 16px;
        max-width: 100%;
        height: 100%;
        min-height: 100vh;
        background: var(--mat-sys-surface, #fff);
        color: var(--mat-sys-on-surface, inherit);
      }
      .duna-dashboard-public app-duna-dashboard {
        display: block;
        flex: 1 1 auto;
        height: 100%;
        min-height: 0;
      }
      .error-card {
        max-width: 640px;
        margin: 24px auto;
        background: var(--mat-sys-surface-container-low, #fafafa);
      }
    `,
  ],
})
export class DunaDashboardPublicComponent implements OnInit, OnDestroy {
  linkUuid: string | null = null;
  linkErrorMessage: string | null = null;

  constructor(private router: Router, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    const urlWithoutQuery = (this.router.url || '').split('?')[0];
    this.linkUuid =
      urlWithoutQuery.split('/').find((segment) => UUID_REGEX.test(segment)) ||
      null;

    if (!this.linkUuid) {
      this.linkErrorMessage =
        'Der blev ikke fundet et gyldigt dashboard-link i adressen. Et korrekt link ser ud som /shared-dashboard/efterfulgt af et UUID.';
    }
    this.cdr.detectChanges();
  }

  ngOnDestroy(): void {}
}
